export const PCT_Y_AXIS_ID = 'pct-y-axis'

export const CUSTOM_CHART_TITLE_CLASS = 'custom-chart-title'

export const HIGHCHARTS_CONTAINER_CLASS = 'highcharts-container'
export const HIGHCHARTS_EXPORTING_GROUP_CLASS = 'highcharts-exporting-group'
export const HIGHCHARTS_PLOT_BACKGROUND_CLASS = 'highcharts-plot-background'
export const HIGHCHARTS_RANGE_SELECTOR_GROUP_CLASS =
  'highcharts-range-selector-group'
export const HIGHCHARTS_STOCKTOOLS_WRAPPER_CLASS =
  'highcharts-stocktools-wrapper'
export const HIGHCHARTS_TITLE_CLASS = 'highcharts-title'

export const MONTHS_PT_BR = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
]

export const WIDESCREEN_HEIGHT_IN = 7.5
export const WIDESCREEN_WIDTH_IN = 13.33

export const BASE_PLACEHOLDER_HEIGHT_IN = WIDESCREEN_HEIGHT_IN * 0.75
export const BASE_PLACEHOLDER_WIDTH_IN = WIDESCREEN_WIDTH_IN * 0.9
export const INITIAL_X_POSITION_IN = WIDESCREEN_WIDTH_IN * 0.05
export const INITIAL_Y_POSITION_IN = 1.6
export const IMAGE_GAP_IN = 0.2

export const MAIN_PAGE_TITLE = 'MAIN_PAGE'
export const SLIDE_PAGE_TITLE = 'SLIDE_PAGE'
